
import { useContext } from "react";
import SuperAdmin from "../../components/SuperAdmin";
import CustomerAdmin from "../../components/CustomerAdmin";
import Dashboard from "../../components/Dashboard";
import { ApplicationContext } from "../../utils/contextsProviders";

const Home = () => {
  const { user } = useContext(ApplicationContext);

  return (
    <div>
      {user?.role === "SuperAdmin" && <SuperAdmin />}
      {user?.role === "CustomerAdmin" && <CustomerAdmin adminId={user?.id} />}
      {user?.role === "CustomerUser" && <Dashboard />}
    </div>
  );
};

export default Home;
